module.exports = __webpack_public_path__ + "static/media/bartelverkruijssen.86d02ace.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bartelverkruijssen.webp
// module id = 805
// module chunks = 0